import React, {useState, useEffect} from 'react';
import './App.css';
// import { useTheme } from '@mui/material/styles';
import FirstLevel from './Components/FirstLevel';
import { styled } from '@mui/material/styles';

import { Button } from '@mui/material';


const ColorButton = styled(Button)(({ theme }) => ({
    color: '#fff',
    backgroundColor: '#2642a6',
    '&:hover': {
      backgroundColor: '#152e87',
    },
    fontWeight: '700'
  }));


const App = () => {
	// const theme = useTheme();
  
	// const [firstCategory, setFirstCategory] = useState(0);
	const [showSplash, setShowSplash] = useState(true);
	const [clicked, setClicked] = useState(false);
	const selectCategory = (category) => {
		setTimeout(function(){
			// setFirstCategory(category);
			setCurrentCategoryId(category);
			setHistory(oldArray => [...oldArray, category]);
			localStorage.setItem('gfk_history', JSON.stringify(history));
			// console.log(history);
		}, 700)
	};
	const [currentCategoryId, setCurrentCategoryId] = useState(0)
	const [history, setHistory] = useState([]);
	
	function handleClickBack() {
		setTimeout(function(){
			if(history.length > 1) {
				// setFirstCategory(history[history.length-2]);
				setCurrentCategoryId(history[history.length-2]);
			} else {
				// setFirstCategory(0);
				setCurrentCategoryId(0);
			}
			setHistory((oldArray) => (oldArray.slice(0,-1)));
			localStorage.setItem('gfk_history', JSON.stringify(history));
			// console.log(history);
		}, 700);
	}

	
	function handleSplashClick() {
		setClicked(true);
		setTimeout(function(){
			setShowSplash(false);
		}, 400)	
	};

	useEffect(() => {
		const historyStorage = localStorage.getItem('gfk_history');
		const historyArr = JSON.parse(historyStorage);
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const back = urlParams.get('b')

		if(historyArr && back == 1) {
			if(historyArr.length > 0) {
				setCurrentCategoryId(historyArr[historyArr.length - 1]);
				setShowSplash(false);
				setHistory(historyArr);
			}
		}

		}, []);

	return (
		<>
		
		<div className="gfk-select">
			{showSplash ? (
				<div className={`gfk-splash ${clicked ? "gfk-splash-out" : ""}`}>
					<h1></h1>
					<ColorButton variant="contained" onClick={ handleSplashClick }>
						Pokaż ofertę
					</ColorButton>
				</div>
			) : (
				<FirstLevel selectCategory={selectCategory} categoryId={currentCategoryId} history={history} handleClickBack={handleClickBack}></FirstLevel>
			)}
		</div>
		</>
	);
}


export default App;
